export default __webpack_public_path__ + "static/401-a9fbfb85d44e9fbbb67e4450f272e343.gif";